<template>
  <span v-if="showWarning" class="m-t-z theme-style-caption-alt-error">
    <s-label type="error" title="Software is outdated" data-testid="software-outdated">
      <template v-slot:tooltip>
        Your Suade software version is more than 3 months old. Please contact Suade support to upgrade your version.
      </template>
    </s-label>
  </span>
</template>

<script>
  import API from '@/services/api';

  export default {
    name: 'VersionWarning',
    props: ['env'],
    data() {
      return {
        suadeVersion: 'dev',
      };
    },
    computed: {
      versionAge() {
        if (this.suadeVersion === 'dev') {
          return 0;
        }

        let dateObj;
        const newFormatMatch = this.suadeVersion?.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2})(\d{2})/);

        if (newFormatMatch) {
          const [, year, month, day, hour, minute] = newFormatMatch.map(Number);
          dateObj = new Date(year, month - 1, day, hour, minute);
        } else {
          // Match the old format: YYMMDDHHMM-...
          const oldFormatMatch = this.suadeVersion?.match(/^(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/);
          if (oldFormatMatch) {
            const [, yy, mm, dd, hh, min] = oldFormatMatch.map(Number);
            const year = 2000 + yy;
            dateObj = new Date(year, mm - 1, dd, hh, min);
          }
        }

        return dateObj ? Date.now() / 1000 - dateObj?.getTime() / 1000 : 0;
      },
      showWarning() {
        return this.versionAge > 90 * 24 * 3600;
      },
    },
    created() {
      API.getSystemVersion()
        .then((version) => {
          this.$store.dispatch('system/setVersion', version);
          this.suadeVersion = version;
        })
        .catch(() => {
          // noop to handle uncaught exception error that is triggered here in prod when logging out via logout url
          // any errors that we get are already caught in api.js
        });
    },
  };
</script>
